import { baseColors } from '@fairhq/common'
import { TaskStatus } from 'store/tasks/types'

export const getTaskStatusColors = (status: string) => {
  switch (status) {
    case TaskStatus.IN_PROGRESS:
      return {
        backgroundColor: baseColors.boldActionSecondary,
        color: baseColors.contentContent,
        borderColor: baseColors.borderDefault,
      }
    case TaskStatus.NOT_STARTED:
      return {
        backgroundColor: baseColors.backgroundPrimaryAction,
        color: baseColors.contentInverseContent,
        borderColor: baseColors.borderDefault,
      }
    case TaskStatus.COMPLETED:
      return {
        backgroundColor: baseColors.backgroundCard,
        color: baseColors.contentContent,
        borderColor: baseColors.borderBackground,
      }
    case TaskStatus.SKIPPED:
    default:
      return {
        backgroundColor: baseColors.statesDisabledBackground,
        color: baseColors.contentDisabled,
        borderColor: baseColors.statesDisabledBorder,
      }
  }
}
